import styles from './EmptyState.module.scss';
import { useTranslation } from "next-i18next";
import cn from 'classnames';
import { P3 } from '@/lib/ui/components/Typography';
import { Button } from '@/lib/ui/components/Buttons';
import { FeedBackModal, modal } from "@/lib/ui/components/Modal";
import { FC } from 'react';

type EmptyStateProps = {
    resetFilters: () => void;
}

export const EmptyState: FC<EmptyStateProps> = ({resetFilters}) => {
    const { t } = useTranslation("index");
    const toCallModal = () => {
        modal.open(<FeedBackModal leadType='SALE' eventName={['sale']}/>, {isFeedBack: true});
      };
    return (
        <div className={styles.emptyState}>
            <div className={cn(styles.container, styles.emptyState__info)}>
                <P3 className={styles.emptyState__text}>{t('emptyResult')}</P3>
                <P3 className={styles.emptyState__text}>{t('callManager')}</P3>
                <div className={styles.emptyState__buttonWrapper}>
                    <Button as={'button'} type={'button'} label={t('form.buttons.requestACall')} theme={'dark'} size={'lg'} onClick={toCallModal}/>
                    <Button as={'button'} type={'button'} label={t('resetFilters')} theme={'secondary'} size={'lg'} onClick={resetFilters}/>
                </div>
            </div>
        </div>
    )
}